import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';

interface AuthLayoutProps {
  children: React.ReactNode;
  title?: string;
  subtitle?: string;
  showBranding?: boolean;
  maxWidth?: number;
}

export const AuthLayout: React.FC<AuthLayoutProps> = ({
  children,
  title,
  subtitle,
  showBranding = true,
  maxWidth = 400,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        // Brand color only. The background photo was removed at the Ministry's
        // request; the gradient keeps this from reading as one flat block.
        backgroundColor: theme.palette.primary.main,
        backgroundImage: `linear-gradient(135deg, ${alpha(
          theme.palette.primary.main,
          0.25,
        )} 0%, ${alpha(theme.palette.primary.dark, 0.2)} 100%)`,
        padding: 2,
      }}
    >
      <Paper
        elevation={10}
        sx={{
          p: 4,
          width: '100%',
          maxWidth,
          borderRadius: 2,
        }}
      >
        {showBranding && (
          <Box sx={{ textAlign: 'center', mb: 3 }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                mb: 2,
              }}
            >
              <Box
                component="img"
                src="/img/moh-logo.webp"
                alt="Ministry of Health Logo"
                sx={{
                  height: 88,
                  width: 88,
                  borderRadius: '50%',
                  objectFit: 'cover',
                }}
              />
            </Box>
            {title && (
              <Typography
                variant="h6"
                component="h1"
                fontWeight="bold"
                sx={{ color: 'primary.main' }}
              >
                {title}
              </Typography>
            )}
            {subtitle && (
              <Typography variant="subtitle1" color="text.secondary">
                {subtitle}
              </Typography>
            )}
          </Box>
        )}
        {children}
        <Typography
          variant="caption"
          align="center"
          color="text.secondary"
          sx={{ display: 'block', mt: 2 }}
        >
          Developed by Infozy, Inc., Monrovia, Liberia
        </Typography>
      </Paper>
    </Box>
  );
};
